import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import Hero_support_tickets from './Hero_support_tickets';
import Previous_Support_Tickets from './Previous_Support_Tickets';
import { SupportTickets } from "../../../../api/Supporttickets";
import { errorToast, infoToast, successToast } from '../../../../_helper/helper';


function Supportandtickets({itDashboard}) {
  const [allTickets, setAllTickets] = useState([]);
  const [supportCreatedTickets, setSupportCreatedTickets] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [priority, setPriority] = useState("");
  const [ticketStatus, setTicketStatus] = useState('open')
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [modaltype, setmodaltype] = useState('add');
  const [selectedTicketForEdit, setselectedTicketForEdit] = useState();
  // const [pageLoading, setpageLoading] = useState(false)


  const getAllTickets = async () => {
    try {
      // setpageLoading(true);
      const userData = JSON.parse(localStorage.getItem("userData"));
      const payload = {
        client_id: userData?.client?.id,
        factory_id: userData?.factory?.id,
      };

      const res = await SupportTickets.getAllTickets(payload); // ✅ Payload added

      if (res?.status === 200) {
        const updatedData = res.data.data?.reverse()
        setAllTickets(updatedData);
        // setpageLoading(false);
        // console.log("Tickets fetched:", res.data.data);
      } else {
        // setpageLoading(false);
        console.warn("Failed to fetch tickets:", res);
      }
    } catch (error) {
      // setpageLoading(false);
      console.error("Error while fetching tickets:", error);
    }
  };


  const handleSubmit = async (e) => {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (!priority || !query) {
      errorToast("Please fill out both fields.");
      return;
    }
    let payload = {};
    if (modaltype === 'edit') {
      payload = {
        ticket_id: selectedTicketForEdit?.ticket_id,
        generated_by: userData?.user?.id || 50,
        client_id: userData?.client?.id,
        factory_id: userData?.factory?.id,
        priority: priority,
        query: query,
        status: ticketStatus,
        comment: "",
      };
    }
    else {
      payload = {
        ticket_id: 0,
        generated_by: userData?.user?.id || 50,
        client_id: userData?.client?.id,
        factory_id: userData?.factory?.id,
        priority: priority,
        status: ticketStatus,
        query: query,
        comment: "",
      };
    }
    try {
      setLoading(true);
      const res = await SupportTickets.Createandupdate(payload);

      if (res.status === 200) {
        successToast(`Support ticket ${modaltype == 'add' ? 'submitted' : 'updated'} successfully!`);
        // getintickets()

        setModalOpen(false);
        setPriority("");
        setQuery("");
        getAllTickets(); // Refresh the ticket list after submission
      } else {
        errorToast("Submission failed. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      errorToast("An error occurred while submitting the ticket. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllTickets();
  }, []);
  const handleEditClick = (ticket) => {
    console.log('ticketsss', ticket)
    setPriority(ticket.priority);
    setQuery(ticket.query);
    setmodaltype('edit')
    setTicketStatus(ticket.status)
    setModalOpen(true);
    setselectedTicketForEdit(ticket);
  }
  useEffect(() => {
    if (modalOpen == false) {
      setPriority("");
      setQuery("");
      setmodaltype('add');
      setselectedTicketForEdit(null);
    }
  }, [modalOpen])

  return (
    <Container fluid>
      <hr />
      <h1 style={{ fontSize: "24px", color: "#1D67AA", fontWeight: "600" }}>
        Support & Tickets
      </h1>
      <p style={{ color: "#535353", fontSize: "14px" }}>
        2025 - Week 26
      </p>
      
        <>
        {/* Ticket Creation Modal */}
        <Hero_support_tickets
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          priority={priority}
          setPriority={setPriority}
          query={query}
          setQuery={setQuery}
          handleSubmit={handleSubmit}
          loading={loading}
          modaltype={modaltype}
          ticketStatus={ticketStatus}
          setTicketStatus={setTicketStatus}
          itDashboard={itDashboard}
          
        />
  
        {/* Tickets List */}
        <Previous_Support_Tickets previousTickets={allTickets} handleEditClick={handleEditClick} />
        </>
      
     
    </Container>
  );
}

export default Supportandtickets;
